// extracted by mini-css-extract-plugin
module.exports = {"drop":"DropFile_drop__1h7tv","active":"DropFile_active__s9fcg","wrapper":"DropFile_wrapper__3y3BZ","label":"DropFile_label__1ypUf"};